/** Decodes the hexadecimal escape sequences commonly found in imported quiz text. */
export const decodeTextEscapes = (value: string) =>
	value
		.replace(/\\u([\da-fA-F]{4})/g, (_, codePoint: string) =>
			String.fromCharCode(Number.parseInt(codePoint, 16)),
		)
		.replace(/\\x([\da-fA-F]{2})/g, (_, byte: string) =>
			String.fromCharCode(Number.parseInt(byte, 16)),
		);
